import { AgoraRTCProvider } from 'agora-rtc-react';
import AgoraRTC from 'agora-rtc-sdk-ng';
import React from 'react';
import ReactDOM from 'react-dom/client';
import "../node_modules/bootstrap-icons/font/bootstrap-icons.css";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import App from './App';
import AppContextProvider from "./ContextApi/AppContext";
import './index.css';
import reportWebVitals from './reportWebVitals';


// fonts started
import "./Assets/fonts/font-family/avenir-next-medium.ttf";
import "./Assets/fonts/font-family/AvenirNextLTPro-Bold.ttf";
import "./Assets/fonts/font-family/AvenirNextLTPro-Regular.ttf";
import "./Assets/fonts/font-family/Recoleta-Medium.ttf";
import "./Assets/fonts/font-family/recoleta-regulardemo.ttf";
import "./Assets/fonts/font-family/RecoletaBold.ttf";


// Initialize Agora client
const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

const root = ReactDOM.createRoot(document.getElementById('root'));

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
}


// Initialize with proper environment checks
const initializeApp = () => {
  root.render(
    // <GoogleOAuthProvider clientId={OauthClientId}>
    <React.StrictMode>
      <AgoraRTCProvider client={client}>
        <AppContextProvider>
          <App/>
        </AppContextProvider>
      </AgoraRTCProvider>
    </React.StrictMode>
    // </GoogleOAuthProvider>

  );

  reportWebVitals();

};

initializeApp();